<p-confirmdialog header="Are you sure?" icon="pi pi-exclamation-triangle"></p-confirmdialog>

<p-dialog header="Email customers" [(visible)]="showEmailCustomers" [style]="{width: '75vw', height: '75vw'}" [baseZIndex]="10000"  [modal]="true">
  <div class="surface-card p-4 shadow-2 border-round" style="margin-top:5px; height: calc(75vh - 50px);">
    <div class="field mb-4 col-12">
      <p>If you would like to email all customers that have booked this event to inform them of the cancellation, please choose a template below, fill out any information and click 'Email customers'. If you want to just cancel the event and not email customers, just click 'Don't email customers'</p>
    </div>
    <div class="field mb-4 col-12" style="margin-top: -40px; width:100%;">
      <label for="template" class="font-medium">Email Template</label>
      <br>
        <p-select [style]="{'width': '100%'}" [options]="ListEmailTemplates" [(ngModel)]="SelectedEmailTemplate" optionLabel="name" placeholder="Select a template" (onChange)="changeTemplate()"></p-select>
      </div>
      @if (EmailContainsDynamicText) {
        <div class="field mb-4 col-12" style="margin-top: -32px">
          <p-button [style]="{'width': '100%'}" icon="pi pi-pencil" label="{{DynamicContentButton}}" styleClass="p-button p-button-danger" (click)="AddDynamicText()"></p-button>
        </div>
      }
      <div style="overflow-x: hidden; height: calc(75vh - 348px)">
        <div [innerHTML]="ExampleEmail | safe: 'html'">
        </div>
      </div>

    </div>
    <ng-template #footer>

      @if (!textValid) {
        <div class="text-danger" Style="float:left; margin-top: 17px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your email must contain some text.</div>
      }
      @if (!textValidDT) {
        <div class="text-danger" Style="float:left; margin-top: 17px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You complete all of your Dynamic Text areas.</div>
      }

      <p-button icon="pi pi-check" label="Email customers" styleClass="p-button p-button-success" (click)="EmailCustomersAndCancelEvent()"></p-button>
      @if (!DontShowNoEmailButton) {
        <span>
          &nbsp;
          <p-button icon="pi pi-times" label="Don't email customers" styleClass="p-button p-button-danger"  (click)="CancelEvent(SelectedEvent, SelectedEventDate)"></p-button>
        </span>
      }

      @if (ShowCancelButton) {
        <span>
          &nbsp;
          <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-danger"  (click)="closeModal()"></p-button>
        </span>
      }
    </ng-template>

  </p-dialog>


  <p-dialog header="Complete Dynamic Text" [(visible)]="ShowDynamicTextEditor" [style]="{width: '75vw', height: '75vw'}" [baseZIndex]="10000"  [modal]="true">
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:5px; height: calc(75vh - 50px);overflow-x: hidden;">

      <div class="field mb-4 col-12">
        <p>Please fill out the text for each of your dynamic text areas</p>
      </div>
      @for (c of dynamicTextArray; track c) {
        <div  class="field mb-4 col-12" style="margin-top: -40px; width:100%;">
          <label for="template" class="font-medium">Dynamic Text {{c.index + 1}}</label>
          <br>
            <textarea pInputText [(ngModel)]="c.text" style="width:100%"></textarea>
          </div>
        }

      </div>
      <ng-template #footer>
        <p-button icon="pi pi-check" label="Save Text" styleClass="p-button p-button-success" (click)="SaveText()"></p-button>
        &nbsp;
        <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-danger"  (click)="closeModal()"></p-button>
      </ng-template>

    </p-dialog>

    @if (!AccessAllowed && CompletedLoading) {
      <div>
        <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
      </div>
    }

    @if (ListEvents && AccessAllowed) {
      <div class="p-3 flex flex-column flex-auto">
        <div class="text-900 font-medium text-xl mb-3">
          <h3>Events</h3>
        </div>
        <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
          <span class="pi pi-info-circle" style="margin-right:2px;"></span> Events is where you define ticketed events you sell.  This is the section that brings all the other elements together, allowing us to calculate availability and price for a booking.
        </p>
        <!-- The desktop layout is the original. Below 1025px wide the compact layout is used
        instead - see isMobile. -->
        @if (!isMobile) {
          <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
            <div style="width: 200px;float: left;">
              <p-select [style]="{'width': '200px', 'text-align': 'left'}" [options]="ListEventDateFilter" [(ngModel)]="SelectedEventDateFilter" optionLabel="name" (onChange)="changeEventDateFilter()"></p-select>
            </div>
            <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon ="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
            </p-togglebutton>
            <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
              <i class="pi pi-search"></i>
              @if (ListEvents) {
                <input  pInputText type="text" (input)="eventsTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Event Name"/>
              }
            </span>
            <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="addNewEvent()">
              <span class="pi pi-plus" style="margin-right:8px;"></span>
              <span>Add</span>
            </button>
            &nbsp;
            <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
              <span class="pi pi-trash" style="margin-right:8px;"></span>
              <span i18>Disable</span>
            </button>
            &nbsp;
            <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="exportEvents()" pTooltip="Export to CSV" tooltipPosition="bottom">
              <span class="pi pi-file-excel" style="margin-right:8px;"></span>
              <span>Export</span>
            </button>
          </div>
        }
        @if (isMobile) {
          <!-- The same toolbar as every other list page on a phone - see list-toolbar in styles.css:
          the date filter and search box a full row each, the buttons two to a row. -->
          <div class="list-toolbar">
            <div>
              <p-select [options]="ListEventDateFilter" [(ngModel)]="SelectedEventDateFilter" optionLabel="name" (onChange)="changeEventDateFilter()"></p-select>
            </div>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              @if (ListEvents) {
                <input pInputText type="text" (input)="eventsTable.filterGlobal($event.target.value, 'contains')" placeholder="Event Name"/>
              }
            </span>
            <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon ="pi pi-check" [style]="{'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal'}" (click)="toggleDisabled()">
            </p-togglebutton>
            <button pButton type="button" class="p-button-sm p-element p-ripple p-button p-component" (click)="exportEvents()" pTooltip="Export to CSV" tooltipPosition="bottom">
              <span class="pi pi-file-excel" style="margin-right:8px;"></span>
              <span>Export</span>
            </button>
            <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="addNewEvent()">
              <span class="pi pi-plus" style="margin-right:8px;"></span>
              <span>Add</span>
            </button>
            <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
              <span class="pi pi-trash" style="margin-right:8px;"></span>
              <span i18>Disable</span>
            </button>
          </div>
        }
        <div class="surface-card p-4 shadow-2 border-round">
          <p-table #eventsTable
            [value]="ListEvents" [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true" responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            [rowsPerPageOptions]="[10,25,50]"
            [globalFilterFields]="['name']"
            [(selection)]="selectedItems"
            responsiveLayout="scroll"
            datakey="TagID"
            [selectionPageOnly]="true">
            <ng-template #header>
              @if (!isMobile) {
                <tr>
                  <th>
                    <p-tableheadercheckbox></p-tableheadercheckbox>
                  </th>
                  <th pSortableColumn="name" width="80%">Name
                  </th>
                  <th width="20%"></th>
                </tr>
              }
              @if (isMobile) {
                <tr>
                  <th style="width: 3rem;">
                    <p-tableheadercheckbox></p-tableheadercheckbox>
                  </th>
                  <th pSortableColumn="name">Name</th>
                </tr>
              }
            </ng-template>
            <ng-template #body let-data>
              @if (!isMobile) {
                <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                  <td>
                    <p-tablecheckbox [value]="data"></p-tablecheckbox>
                  </td>
                  <td>
                    <div class="surface-card p-4 shadow-2 border-round">
                      <table style="width:100 !important">
                        <tr>
                          <td width="85%" style="text-align: center; padding-bottom:20px;" colspan="2">
                            <!-- <span style="font-weight:bold">{{data.name}}&nbsp;({{data.eventdates[0].startdatetime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}&nbsp;-&nbsp;{{data.eventdates[data.eventdates.length - 1].enddatetime | date:'dd/MM/yyyy HH:mm' : 'UTC'}})</span> -->
                            <span style="font-weight:bold">{{data.name}}</span>
                          </td>
                          <!-- The pie has a box of its own size and fills it, centred down the full height of
                          the card. It used to sit in a box 50px tall that it overflowed to 150px, and was
                          pulled into place with a negative margin - which only held while the page laid out
                          exactly as it had when it loaded, so resizing the window dropped it out of the card. -->
                          <td rowspan="3" style="vertical-align: middle; width: 140px;">
                            <div style="width:110px; height:110px; margin-left:20px;">
                              <p-chart type="pie" [data]="data.chartData" [options]="pieOptions" width="110px" height="110px"></p-chart>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: center">
                            <span style="font-size: 20px">Total Tickets</span>
                          </td>
                          <td style="text-align: center">
                            <span style="font-size: 20px">Tickets Sold</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: center">
                            <span style="font-size: 20px; font-weight:bold">{{data.totalnumberoftickets}}</span>
                          </td>
                          <td style="text-align: center">
                            <span style="font-size: 20px; font-weight:bold">{{data.totalnumberofticketssold}}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                  <td>
                    <table style="width:100 !important">
                      <tr>
                        <td>
                          <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:150px;height:70px;margin-bottom:10px;margin-right:10px" (click)="editData(data.eventid);">
                            <span class="pi pi-pencil" style="margin-right:8px;"></span>
                            <span i18n>Edit</span>
                          </button>
                        </td>
                        <!-- <td>
                        <button disabled = "true" pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="width:150px;height:70px;margin-bottom:10px;margin-right:10px" (click)="copydata(data.eventid)">
                          <span class="pi pi-copy" style="margin-right:8px;"></span>
                          <span i18n>Copy</span>
                        </button>
                      </td> -->
                      <td>
                        <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="width:150px;height:70px;margin-top:-10px;" (click)="disableData(data.eventid)">
                          <span class="pi pi-trash" style="margin-right:8px;"></span>
                          <span i18n>Disable</span>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        @if (!data.showinnerbookings) {
                          <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="width:313px;height:70px" (click)="openEvent(data)">
                            <span class="pi pi-chevron-down" style="margin-right:8px;"></span>
                            <span i18n>Show Events</span>
                          </button>
                        }
                        @if (data.showinnerbookings) {
                          <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="width:313px;height:70px" (click)="openEvent(data)">
                            <span class="pi pi-chevron-up" style="margin-right:8px;"></span>
                            <span i18n>Hide Events</span>
                          </button>
                        }
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            }
            @if (isMobile) {
              <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td style="width: 3rem; vertical-align: middle;">
                  <p-tablecheckbox [value]="data"></p-tablecheckbox>
                </td>
                <!-- One card per event. On a wide screen the details, the chart and the buttons sit
                side by side; on a phone they stack, and the buttons share the full width. -->
                <td>
                  <!-- One compact row per event. On a wide screen: the event and how it is selling on
                  the left, the buttons in a single line on the right. On a phone the two stack
                  and the buttons share the width. -->
                  <div class="ev-row">
                    <div class="ev-info">
                      <div class="ev-name">{{data.name}}</div>
                      <!-- The pie has a slice per date, sized by the tickets sold on it, so it shows how
                      sales split across the event's dates - which is why it is a pie and not a
                      single bar. -->
                      <div class="ev-stats">
                        <div class="ev-stat">
                          <div class="ev-stat-label">Total Tickets</div>
                          <div class="ev-stat-value">{{data.totalnumberoftickets}}</div>
                        </div>
                        <div class="ev-stat">
                          <div class="ev-stat-label">Tickets Sold</div>
                          <div class="ev-stat-value">{{data.totalnumberofticketssold}}</div>
                        </div>
                        <div class="ev-chart">
                          <p-chart type="pie" [data]="data.chartData" [options]="pieOptions" width="80px" height="80px"></p-chart>
                        </div>
                      </div>
                    </div>
                    <div class="ev-buttons">
                      <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="editData(data.eventid);">
                        <span class="pi pi-pencil" style="margin-right:8px;"></span>
                        <span i18n>Edit</span>
                      </button>
                      <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.eventid)">
                        <span class="pi pi-trash" style="margin-right:8px;"></span>
                        <span i18n>Disable</span>
                      </button>
                      <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component ev-toggle" (click)="openEvent(data)">
                        <span class="pi" [ngClass]="data.showinnerbookings ? 'pi-chevron-up' : 'pi-chevron-down'" style="margin-right:8px;"></span>
                        <span>{{data.showinnerbookings ? 'Hide Events' : 'Show Events'}}</span>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            }
            @if (data.showinnerbookings) {
              <tr>
                <td colspan="6">
                  <p-table #subEventsTable
                    [value]="data.eventdates" sortField="name" [paginator]="true" [rows]="10"
                    [showCurrentPageReport]="true" responsiveLayout="scroll"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    [rowsPerPageOptions]="[10,25,50]"
                    [globalFilterFields]="['name']"
                    [(selection)]="selectedItems"
                    responsiveLayout="scroll"
                    datakey="TagID"
                    [selectionPageOnly]="true">
                    <ng-template #header>
                      <tr>
                        <th width="30%">From Date</th>
                        <th width="30%">To Date</th>
                        <th width="15%">Total Tickets</th>
                        <th width="15%">Tickets Sold</th>
                        <th width="5%">&nbsp;</th>
                        <th width="5%">&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-datesdata>
                      @if (!datesdata.cancelled) {
                        <tr [ngStyle]="{'background-color': (datesdata.cancelled==true) ? '#fee' : '#ffffff'}">
                          <td>{{datesdata.startdatetime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</td>
                          <td>{{datesdata.enddatetime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</td>
                          <td>{{datesdata.nooftickets}}</td>
                          <td>{{datesdata.noofticketssold}}</td>
                          <td>
                            @if (!datesdata.cancelled) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="width:113px;height:50px" (click)="confirm(data, datesdata)">
                                <span class="pi pi-times" style="margin-right:8px;"></span>
                                <span i18n>Cancel</span>
                              </button>
                            }
                            @if (datesdata.cancelled) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="width:113px;height:50px" (click)="resendEmail(data, datesdata)">
                                <span class="pi pi-send" style="margin-right:8px;"></span>
                                <span i18n>Resend</span>
                              </button>
                            }
                          </td>
                          @if (!datesdata.showEventDateBookings) {
                            <td>
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="width:170px;height:50px;margin-left:-20px;" (click)="openBookings(data, datesdata)">
                                <span class="pi pi-chevron-down" style="margin-right:8px;"></span>
                                <span i18n>Show Bookings</span>
                              </button>
                            </td>
                          }
                          @if (datesdata.showEventDateBookings) {
                            <td>
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="width:170px;height:50px;margin-left:-20px;" (click)="openBookings(data, datesdata)">
                                <span class="pi pi-chevron-up" style="margin-right:8px;"></span>
                                <span i18n>Hide Bookings</span>
                              </button>
                            </td>
                          }
                        </tr>
                      }
                      @if (datesdata.cancelled) {
                        <tr style="background-color:#fee">
                          <td><s>{{datesdata.startdatetime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</s></td>
                          <td><s>{{datesdata.enddatetime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</s></td>
                          <td><s>{{datesdata.nooftickets}}</s></td>
                          <td><s>{{datesdata.noofticketssold}}</s></td>
                          <td>
                            @if (!datesdata.cancelled) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" disabled="true" style="width:113px;height:50px">
                                <span class="pi pi-times" style="margin-right:8px;"></span>
                                <span i18n>Cancel</span>
                              </button>
                            }
                            @if (datesdata.cancelled) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" (click)="resendEmail(data, datesdata)" style="width:113px;height:50px">
                                <span class="pi pi-send" style="margin-right:8px;"></span>
                                <span i18n>Resend</span>
                              </button>
                            }
                          </td>
                          @if (!datesdata.showEventDateBookings) {
                            <td>
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="width:170px;height:50px;margin-left:-20px;" (click)="openBookings(data, datesdata)">
                                <span class="pi pi-chevron-down" style="margin-right:8px;"></span>
                                <span i18n>Show Bookings</span>
                              </button>
                            </td>
                          }
                          @if (datesdata.showEventDateBookings) {
                            <td>
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="width:170px;height:50px;margin-left:-20px;" (click)="openBookings(data, datesdata)">
                                <span class="pi pi-chevron-up" style="margin-right:8px;"></span>
                                <span i18n>Hide Bookings</span>
                              </button>
                            </td>
                          }
                        </tr>
                      }
                      @if (datesdata.showEventDateBookings) {
                        <tr>
                          <td colspan="6">
                            <p-table  #resourceTable
                              [value]="datesdata.eventDateBookings" [paginator]="true" [rows]="10"
                              [showCurrentPageReport]="true" responsiveLayout="scroll"
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                              [rowsPerPageOptions]="[10,25,50]"
                              [globalFilterFields]="['name', 'bookingid', 'bookingidhr', 'packageName']"
                              [(selection)]="selectedItems"
                              responsiveLayout="scroll"
                              datakey="resourceID"
                              [selectionPageOnly]="true">
                              <ng-template #header>
                                <tr>
                                  <th width="1%">
                                    &nbsp;
                                  </th>
                                  <th width="1%">
                                    &nbsp;
                                  </th>
                                  <th pSortableColumn="bookingid" width="8%">Sales ID
                                    <p-sorticon [field]="bookingidhr"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="startTime" width="10%">Start Date
                                    <p-sorticon [field]="starttime"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="startTime" width="3%">Start
                                    <p-sorticon [field]="starttime"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="name" width="10%">Name
                                    <p-sorticon [field]="name"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="name" width="18%">Admissions
                                    <p-sorticon [field]="admissions"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="packageName" width="15%">Package
                                    <p-sorticon [field]="packageName"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="guests" width="6%">Guests
                                    <p-sorticon [field]="guests"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="total" width="5%">Total
                                    <p-sorticon [field]="total"></p-sorticon>
                                  </th>
                                  <th pSortableColumn="outstanding" width="5%">O/S
                                    <p-sorticon [field]="outstanding"></p-sorticon>
                                  </th>
                                  <th width="15%">
                                    Extras
                                  </th>
                                  <th width="10%">
                                    Allergy
                                  </th>
                                  <!-- <th></th>
                                  <th></th> -->
                                </tr>
                              </ng-template>
                              <!--<ng-template pTemplate="body" let-data>
                              <tr  onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                                <td (click)="editdatanew(data.bookingid)" >
                                  <span *ngIf="data.publicbooking" class="pi pi-user"></span>
                                </td>
                                <td (click)="editdatanew(data.bookingid)">
                                  <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                                </td>
                                <td (click)="editdatanew(data.bookingid)">{{data.bookingidhr}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.name}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.guests}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.total | currency: CurrencySymbol}}</td>
                                <td (click)="editdatanew(data.bookingid)" *ngIf="data.outstanding <=0">{{data.outstanding | currency: CurrencySymbol}}</td>
                                <td (click)="editdatanew(data.bookingid)" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: CurrencySymbol}}</span></td>
                              </tr>
                            </ng-template> -->
                            <ng-template #body let-data>
                              @if (!data.inProgress && !inProgress  && (data.allergy == '' || data.allergy == null)) {
                                <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                                  <td (click)="editdatanew(data.bookingid)" >
                                    @if (data.publicBooking) {
                                      <span class="pi pi-user"></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingid)">
                                    @if (data.notes != '' && data.notes != null) {
                                      <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.bookingidhr}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.starttime | date:'dd/MM/yy'}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.starttime | date:'HH:mm' : 'UTC'}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.name}} ({{data.phone}})</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.admissions}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.packageName}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.guests}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.total | currency: CurrencySymbol}}</td>
                                  @if (data.outstanding <=0) {
                                    <td (click)="editdatanew(data.bookingid)">{{data.outstanding | currency: CurrencySymbol}}</td>
                                  }
                                  @if (data.outstanding >0) {
                                    <td (click)="editdatanew(data.bookingid)"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: CurrencySymbol}}</span></td>
                                  }
                                  <td (click)="editdatanew(data.bookingid)">{{data.extraslist}}</td>
                                  <td (click)="editdatanew(data.bookingid)">{{data.allergy}}</td>
                                  <!-- <td *ngIf="!data.disabled"><button  pTooltip="Send Booking Confirmation" pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" (click)="emailConf(data.bookingId)" i18>
                                  <span class="pi pi-envelope"></span>
                                </button></td>
                                <td *ngIf="!data.disabled"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.bookingId)" i18>
                                  <span class="pi pi-trash"></span>
                                </button></td>
                                <td *ngIf="data.disabled"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="undisableData(data.bookingId)" i18>
                                  <span class="pi pi-check-circle"></span>
                                </button></td> -->
                              </tr>
                            }
                            @if (!data.inProgress && !inProgress && data.allergy != '' && data.allergy != null) {
                              <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#FFFFB2'}">
                                <td (click)="editdatanew(data.bookingid)" >
                                  @if (data.publicBooking) {
                                    <span class="pi pi-user"></span>
                                  }
                                </td>
                                <td (click)="editdatanew(data.bookingid)">
                                  @if (data.notes != '' && data.notes != null) {
                                    <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                                  }
                                </td>
                                <td (click)="editdatanew(data.bookingid)">{{data.bookingidhr}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.starttime | date:'dd/MM/yy'}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.starttime | date:'HH:mm' : 'UTC'}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.name}} ({{data.phone}})</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.admissions}}</td>
                                <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                                <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                                <td (click)="editdatanew(data.bookingid)">{{data.packageName}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.guests}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.total | currency: CurrencySymbol}}</td>
                                @if (data.outstanding <=0) {
                                  <td (click)="editdatanew(data.bookingid)">{{data.outstanding | currency: CurrencySymbol}}</td>
                                }
                                @if (data.outstanding >0) {
                                  <td (click)="editdatanew(data.bookingid)"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: CurrencySymbol}}</span></td>
                                }
                                <td (click)="editdatanew(data.bookingid)">{{data.extrastext}}</td>
                                <td (click)="editdatanew(data.bookingid)">{{data.allergy}}</td>
                                @if (useCounters) {
                                  <td>
                                    @if (!data.checkedin) {
                                      <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:133px;" (click)="admitall(data.bookingid)">
                                        <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                                        <span>Admit All</span>
                                      </button>
                                    }
                                    @if (data.checkedin) {
                                      <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="width:133px;" (click)="leaveall(data.bookingid)">
                                        <span class="pi pi-sign-out" style="margin-right:8px;"></span>
                                        <span>Leave All</span>
                                      </button>
                                    }
                                  </td>
                                }
                              </tr>
                            }
                          </ng-template>
                        </p-table>
                      </td>
                    </tr>
                  }
                </ng-template>
              </p-table>
            </td>
          </tr>
        }
      </ng-template>
    </p-table>
  </div>
</div>
}
